import React from 'react';
import VerticalAccordion from '../../components/VerticalAccordion/VerticalAccordion';
import BannerImg from '../../Assets/Business/Background.png';
import Icon1 from '../../Assets/Business/mdi-light_truck.png';
import Icon2 from '../../Assets/Business/iconoir_car.png';
import Icon3 from '../../Assets/Business/Vector.png';
import Img1 from '../../Assets/Business/According1.png';
import Img2 from '../../Assets/Business/According2.jpeg';
import Img3 from '../../Assets/Business/According3.jpeg';
import './Business.css';

const businessItems = [
    {
        id: 1,
        title: "Janta Roadways",
        Icon: Icon1,
        imgSrc: Img1,
        description:
            "India’s trusted automobile logistics partner, delivering safe, compliant and damage-free vehicle transportation solutions nationwide since 1982.",
        buttonText: "Explore Logistics →"
    },
    {
        id: 2,
        title: "Prime Automotive",
        Icon: Icon2,
        imgSrc: Img2,
        description:
            "Specialised automotive solutions supporting OEM networks, vehicle handling, and integrated transport operations with precision and care.",
        buttonText: "Explore Prime Automotive →"
    },
    {
        id: 3,
        title: "Hindputra Products",
        Icon: Icon3,
        imgSrc: Img3,
        description:
            "Manufacturing and allied industrial solutions supporting the logistics and automotive ecosystem with reliability and quality standards.",
        buttonText: "Explore Hindputra →"
    },
];

const Business = () => {
    return (
        <div className="business-page">
            {/* Banner Section */}
            <div className="banner-container">
                <img
                    src={BannerImg}
                    alt="Business Banner"
                    className="banner-image"
                />
                <div className="banner-content">
                    <h1 className="banner-title">
                        Driving Growth Across<br />
                        Logistics, Automotive<br />
                        & Allied Industries
                    </h1>
                </div>
            </div>

            {/* Accordion Section */}
            <div className="business-accordion-section">
                <VerticalAccordion items={businessItems} className="white" />
            </div>
        </div>
    );
};

export default Business;
